import { apiClient } from '@/api/client'
import type {
  GrammarCheckRequest,
  GrammarCheckResponse,
  TranslateJaToEnRequest,
  TranslateJaToEnResponse,
  TranslateRequest,
  TranslateResponse,
} from '@/api/type'

export const translateText = async (request: TranslateRequest): Promise<TranslateResponse> => {
  const res = await apiClient.post(`/translate`, request)
  return res.data
}

export const checkGrammar = async (request: GrammarCheckRequest): Promise<GrammarCheckResponse> => {
  const res = await apiClient.post(`/grammar/check`, request)
  return res.data
}

export const translateJaToEn = async (request: TranslateJaToEnRequest): Promise<TranslateJaToEnResponse> => {
  const res = await apiClient.post(`/translate/ja-to-en`, request)
  return res.data
}
